import React, { FC } from 'react';

// import icon from './exclamation.svg';

export const ExclamationSvgComponent: FC = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 512'>
      <path fill='currentColor' d='M72 64c0-17.7-14.3-32-32-32S8 46.3 8 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM40 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z' />
    </svg>
  );
};

// export default icon;
